import React from 'react';

/* The photo, small, or the initial in its place.

   A roster row with no photo is the NORMAL case, not a broken one — on a real event two in ten
   people have never uploaded one — so the fallback has to look deliberate rather than like a
   missing image. Hence a letter on a grey disc and not a broken-image icon or a generic silhouette
   repeated forty times down a list.

   Same markup and the same two classes wherever a list of people is drawn ("who is coming", the
   door), so the rows are the same height on both and nothing jumps when one screen links to the
   other. `.ce-person__avatar` in CompanyEvents.css owns the size. */
const PersonAvatar = ({ person }) => (person && person.photo_url ? (
  <img className="ce-person__avatar" src={person.photo_url} alt="" />
) : (
  <span className="ce-person__avatar ce-person__avatar--empty">
    {(((person || {}).name || (person || {}).email || '?').trim().charAt(0)) || '?'}
  </span>
));

export default PersonAvatar;
